import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import { ForEachModel, ValueToCollection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { Translation } from '@morningtrain/react-translations'
import GoodsUsageTableFooter from './GoodsUsageTableFooter'

export default function GoodsUsageTables () {
  return (
    <ValueToCollection name='table'>
      <ForEachModel>
        <UI.Card tight className='pt-6 sm:pt-10'>
          <UI.CardHeader withPadding>
            <UI.SecondaryHeading>
              <Displays.Text name='key' />
            </UI.SecondaryHeading>
          </UI.CardHeader>
          <ValueToCollection name='collection'>
            <Table striped footer={<GoodsUsageTableFooter />}>
              <Columns.Column
                name='month'
                label={(
                  <UI.WithSubtitle subtitle={(
                    <span dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                  )}
                  >
                    <Translation name='generic.month' />
                  </UI.WithSubtitle>
                )}
              >
                <UI.Text weight='medium'>
                  <Displays.Date name='date' dateFormat='MMMM' />
                </UI.Text>
              </Columns.Column>
              <Columns.Column
                name='kitchen'
                alignment='right'
                label={(
                  <UI.WithSubtitle subtitle={(
                    <UI.Text size='xs'>
                      <Translation name='columns.goodsuage_revenue' />
                    </UI.Text>
                  )}
                  >
                    <Translation name='columns.kitchen' />
                  </UI.WithSubtitle>
                )}
              >
                <UI.SplitValues
                  splitter='/'
                  secondary={<><Displays.Currency
                    name='kitchen_revenue' decimals={0}
                    defaultValue={0}
                               /> | <Displays.Percentage
                                 name='kitchen_percentage'
                                 decimals={0}
                                 defaultValue={0}
                                    />
                             </>}
                >
                  <Displays.Currency name='kitchen' defaultValue={0} decimals={0} />
                </UI.SplitValues>
              </Columns.Column>
              <Columns.Column
                name='bar'
                alignment='right'
                label={(
                  <UI.WithSubtitle subtitle={(
                    <UI.Text size='xs'>
                      <Translation name='columns.goodsuage_revenue' />
                    </UI.Text>
                  )}
                  >
                    <Translation name='columns.bar' />
                  </UI.WithSubtitle>
                )}
              >
                <UI.SplitValues
                  splitter='/'
                  secondary={<><Displays.Currency
                    name='bar_revenue' decimals={0}
                    defaultValue={0}
                               /> | <Displays.Percentage
                                 name='bar_percentage'
                                 decimals={0}
                                 defaultValue={0}
                                    />
                             </>}
                >
                  <Displays.Currency name='bar' defaultValue={0} decimals={0} />
                </UI.SplitValues>
              </Columns.Column>
              <Columns.Column
                name='total'
                alignment='right'
                label={(
                  <UI.WithSubtitle subtitle={(
                    <UI.Text size='xs'>
                      <Translation name='columns.goodsuage_revenue' />
                    </UI.Text>
                  )}
                  >
                    <Translation name='columns.total' />
                  </UI.WithSubtitle>
                )}
              >
                <UI.SplitValues
                  splitter='/'
                  secondary={<><Displays.Currency
                    name='total_revenue' decimals={0}
                    defaultValue={0}
                               /> | <Displays.Percentage
                                 name='total_percentage'
                                 decimals={0}
                                 defaultValue={0}
                                    />
                             </>}
                >
                  <Displays.Currency name='total' defaultValue={0} decimals={0} />
                </UI.SplitValues>
              </Columns.Column>
            </Table>
          </ValueToCollection>
        </UI.Card>
      </ForEachModel>
    </ValueToCollection>
  )
}
